//JavaScript Document

export const SET_WORKSPACE = "SET_WORKSPACE";
